import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router';

import PhoneInput from '../PhoneInput';
import { StandardButton } from '../Button';
import { Form, FloatingLabel } from 'react-bootstrap';
import styles from './JoinForm.module.scss';
import Checkbox from '../Checkbox/Checkbox';
import { dbQueueWithCurDateRef } from '../../../api/queue'
import { db } from '../../../FirebaseConfig';
import { format } from 'date-fns';
import validator from 'validator';

const { ref, update } = require("firebase/database");


export function JoinQueueForm({ queueId, queueInfo, onJoin, isAdmin = false, onAddGuest, onCancel }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [invalidPhone, setInvalidPhone] = useState(false);
  const [email, setEmail] = useState('');
  const [invalidName, setInvalidName] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [ifSave, setIfSave] = useState(false)

  const navigate = useNavigate();

  useEffect(() => {
    const formData = JSON.parse(localStorage.getItem('form'));
    if (formData) {
      setName(formData.name);
      setPhone(formData.phone);
      setEmail(formData.email);
      setIfSave(true);
    }
  }, []);


  const joinQueue = async (newToken) => {
    try {
      const dbRef = dbQueueWithCurDateRef(queueId, '/guests');

      const updateList = {};
      updateList[`/guests/${newToken.id}`] = newToken;
      const date = format(Date.now(), 'yyyy-MM-dd');
      await update(
        ref(db, `queues/${queueId}/daily_stats/${date}`),
        updateList
      );
      if (onJoin) {
        await onJoin(newToken);
      }
    } catch (err) {
      console.error('\tError: ', err.message);
    }
  };

  const handleCancel = () => {
    onCancel(null);
    navigate('/join');
  };
  

  function handleNameChange(e) {
    setName(e.target.value);
    setInvalidName(false)
  }

  function handleEmailChange(e) {
    setEmail(e.target.value);
    setInvalidEmail(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (invalidPhone)
      return;

    if (name === '') {
      setInvalidName(true)
      return
    }

    if (email === '' || !validator.isEmail(email)) {
      setInvalidEmail(true);
      return
    }

    const guestId = `guest-${Date.now().toString(36)}${Math.random().toString(36).substr(2, 9)}`;
    const startTime = (new Date()).toISOString();

    const newToken = {
      id: guestId,
      name, phone,
      email: email,
      status: 'waiting',
      startedTime: startTime,
      queueId: queueInfo.queueId,
      number: queueInfo.totalGuests + 1,
      position: queueInfo.activeGuests + 1,
      startedPosition: queueInfo.activeGuests + 1,
    }

    const formData = JSON.parse(localStorage.getItem('form'));
    if (ifSave && !formData) {
      localStorage.setItem('form', JSON.stringify({ name, phone, email }));
    } else if (!ifSave && formData) {
      localStorage.removeItem('form');
    }

    if (onAddGuest){
      await onAddGuest(newToken);
    } else {
    await joinQueue(newToken);
    }
  }


  return (
    <Form className={styles.formBox} onSubmit={handleSubmit}>
      <div className={styles.formItem}>
        <PhoneInput
          isValid={!invalidPhone}
          setInvalidContact={setInvalidPhone}
          contact={phone}
          onChange={(val) => setPhone(val)}
          data-cypress-name="cy-phonenumber"
        />
      </div>

      <div className={styles.formItem}>
        <FloatingLabel controlId="floatingInput" label="Name" className="mb-3">
          <Form.Control
            type="text"
            placeholder="Name"
            value={name}
            onChange={handleNameChange}
            autoFocus
            required
            data-cypress-name='add-guest-input-name'
          />
          {invalidName && (
            <div className={'text-danger'}>Please provide a name.</div>
          )}
        </FloatingLabel>
      </div>

      <div className={styles.formItem}>
        <FloatingLabel controlId="floatingInput" label="Email" className="mb-3">
          <Form.Control
            type="email"
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
            required
            data-cypress-name='add-guest-input-email'
          />
          {invalidEmail && (
            <div className={'text-danger'}>Please provide a valid email.</div>
          )}
        </FloatingLabel>
      </div>

      {!isAdmin && (
        <Checkbox
          name="saveToLocalStorage"
          label="Save for later"
          checked={ifSave}
          onChange={() => {
            setIfSave(!ifSave);
          }}
        />
      )}
      <div className={styles['vertical-buttons']}>
        <StandardButton variant="contained" onClick={handleSubmit}>
          Join
        </StandardButton>
        <span className={styles.formButtonsSpace} />
        {!isAdmin && (
          <StandardButton outlined onClick={handleCancel}>
            Cancel
          </StandardButton>
        )}
      </div>
    </Form>
  );
}

export default JoinQueueForm;
